export const translation = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About Me",
      process: "Process",
      contact: "Contact",
      submit: "Submit a Document",
    },
    company: {
      title: "Court-Appointed Sworn Translator",
    },

    companyIntro: {
      title: {
        name: "Sophie Guérande",
        subtitle: "Court-Appointed Sworn Translator",
      },

      section1: {
        title: "Indonesian & Malay Certified Translations",
        paragraphs: [
          "With extensive professional experience, I provide certified translations of civil status, administrative, and official documents.",
          "I ensure accuracy, confidentiality, and compliance with legal standards."
        ]
      },

      section2: {
        title: "Language Combinations",
        languages: [
          "Indonesian → French (certified)",
          "French → Indonesian (certified)",
          "Malay → French (certified)",
          "Indonesian → English",
          "English → Indonesian",
        ],
      },

      stats: {
        experience: {
          value: "15+",
          label: "Years of Experience",
        },
        delivery: {
          value: "3–5",
          label: "Business Days",
        },
        documents: {
          value: "800+",
          label: "Documents Translated",
        },
        satisfaction: {
          value: "100%",
          label: "Client Satisfaction",
        },
      },

      cta: {
        button: "Submit a Document",
        note: "Fast, secure and legally recognized translations, delivered by email and post",
      },
    },

    services: {
      title: "Services",

      translation: {
        subtitle: "Certified / Sworn Translations",

        languages: [
          "Indonesian → French",
          "Malay → French",
          "French → Indonesian",
        ],

        intro: "For all your official procedures:",

        sections: [
          {
            title: "Civil Status & Family Documents",
            desc: "Birth certificates, certificates of celibacy, marriage certificates, divorce decrees, death certificates, family record books, etc.",
          },
          {
            title: "Legal Documents",
            desc: "Court rulings, notarial deeds, summonses, powers of attorney, contracts, agreements, etc.",
          },
          {
            title: "Administrative & Academic Documents",
            desc: "Diplomas, transcripts, school certificates, driving licences, identity documents, criminal record extracts, proof of residence, and other administrative documents.",
          },
        ],
      },

      interpreting: {
        title: "Sworn Interpreting",

        languages: [
          "Indonesian → French",
          "French → Indonesian",
        ],

        intro: "Types of interpreting offered:",

        types: [
          {
            title: "Simultaneous Interpreting",
            desc: "Ideal for real-time events such as conferences, seminars and official events",
          },
          {
            title: "Consecutive Interpreting",
            desc: "Suitable for meetings, training sessions, and negotiations",
          },
          {
            title: "Online & Remote Interpreting",
            desc: "By phone or videoconference",
          },
        ],
      },

      cta: {
        submit: "Submit a Document",
      },
    },

    about: {
      title: "About Me",
      section1: {
        title: "Reliable Legal Expertise for Your Life’s Milestones",
        text: "I’m Sophie Guérande, a sworn Indonesian–Malay–French translator and interpreter accredited by the Toulouse Court of Appeal. I help individuals and professionals obtain certified translations of their official documents anywhere in France."
      },
      section2: {
        title: "Cross-Cultural Expertise",
        paragraphs: [
          "My work is rooted in real-life experience between Paris and Jakarta.",
          "After completing two Master’s degrees — one in Applied Foreign Languages (Indonesian–English) and one in International Affairs — I worked for major companies in Jakarta, where I discovered the reality of Indonesian business life and professional culture.",
          "I then spent 11 years at the Embassy of Indonesia in Paris (Consular, Economic and Commercial Services), translating official and administrative documents every day",
          "These experiences gave me a deep understanding of both French and Indonesian institutional and cultural environments. Today, as an independent professional, I work regularly with several French ministries as well as international organisations — and over the past five years, I’ve translated more than 800 official documents."
        ]
      },
      section3: {
        title: "Human Connection & Legal Precision",
        paragraphs: [
          "What drives me above all is the human connection. I know that behind every document lies a life-changing milestone: a marriage, a naturalisation application, a study programme, a move to France, or a legal matter.",
          "My role is to support you with care, clarity and professionalism — while ensuring confidentiality and full legal accuracy."
        ]
      },
      section4: {
        title: "My commitment",
        text: "Clear, reliable and legally-recognised translations — making your administrative procedures as smooth and stress-free as possible."
      }
    },

    process: {
      title: "Translation Process",
      subtitle: "A Simple & Secure Process",

      steps: [
        {
          title: "Send your document",
          desc: "Submit your documents via the secure platform or by email",
        },
        {
          title: "Review & Quote",
          desc: "Receive a personalized quote along with the delivery timeframe",
        },
        {
          title: "Secure Payment",
          desc: "Payment is made by bank transfer to launch the translation process",
        },
        {
          title: "Delivery",
          desc: "Receive your certified translation in PDF by email, followed by the signed original by post",
        },
      ],
    },

    contact: {
      title: "Contact",

      details: {
        email: "Email",
        phone: "Phone",
        address: "Address",
      },

      addressLines: [
        "20 rue Cujas",
        "31000 Toulouse",
        "France",
      ],

      business: {
        title: "Business Registration",
        status: "Self-employed sole trader",
        siret: "SIRET number: 83828090700018",
      },
    },

    submission: {
      title: "Submit a Document",
      subtitle: "Simple & Fast",

      bullets: [
        "Free, no-obligation quote",
        "Upload your document and receive an accurate price and guaranteed delivery timeframe",
        "Full confidentiality is guaranteed",
      ],

      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        file: "Upload File",
        notes: "Notes",

        placeholders: {
          name: "Enter your name",
          email: "Enter your email",
          phone: "Enter your phone number",
          notes: "Additional details or instructions",
        },

        submit: "Submit",
        submitting: "Submitting...",
      },

      messages: {
        uploadRequired: "Please upload a file before submitting.",
        success: "Success",
        error: "Error: Could not submit",
      },
    },

    footer: {
      description:
        "Sophie Guérande - A court-appointed sworn translator for French, Indonesian, and Malay with over 15 years of experience specializing in legal, financial, and business documents.",

      contact: {
        email: "Email",
        phone: "Phone",
        address: "Address",
        addressLines: [
          "20 rue Cujas",
          "31000 Toulouse",
          "France",
        ],
      },

      legal: {
        title: "Legal Information",
        privacy: "Privacy Policy",
        notice: "Legal Notice",
      },

      bottom: "All rights reserved.",
    },
  },

  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      about: "À propos",
      process: "Accompagnement",
      contact: "Contact",
      submit: "Demander un devis",
    },
    company: {
      title: "Traductrice assermentée",
    },

    companyIntro: {
      title: {
        name: "Sophie Guérande",
        subtitle: "Traductrice-interprète assermentée",
      },

      section1: {
        title: "Traductions certifiées en indonésien, malaisien et français",
        paragraphs: [
          "Je vous accompagne dans toutes vos démarches officielles grâce à des traductions certifiées précises et conformes aux exigences légales.",
          "Mon expérience et mon expertise sont à votre service pour vous fournir des traductions reconnues légalement et traitées en toute confidentialité."
        ]
      },

      section2: {
        title: "Combinaisons linguistiques :",
        languages: [
          "Traductions certifiées / assermentées",
          "indonésien ↔ français",
          "malaisien → français",
          "Traductions professionnelles",
          "anglais ↔ indonésien",
        ],
      },

      stats: {
        experience: {
          value: "15+",
          label: "Années d’Expertise",
        },
        delivery: {
          value: "3–5",
          label: "Jours ouvrés Délai standard",
        },
        documents: {
          value: "800+",
          label: "Documents traduits",
        },
        satisfaction: {
          value: "100%",
          label: "Client satisfaction",
        },
      },

      cta: {
        button: "Demander un devis",
        note: "Des traductions rapides, sécurisées et reconnues légalement, envoyées par email et par courrier",
      },
    },

    services: {
      title: "Services",

      translation: {
        subtitle: "Traductions certifiées / assermentées",

        languages: [
          "indonésien → français",
          "malaisien → français",
          "français → indonésien",
        ],

        intro: "Pour toutes vos démarches officielles :",

        sections: [
          {
            title: "État civil et vie familiale",
            desc: "Actes de naissance, certificats de célibat, actes de mariage, de divorce et de décès, livrets de famille, etc.",
          },
          {
            title: "Documents juridiques",
            desc: "Jugements, actes notariés, assignations, procurations, contrats, conventions, etc.",
          },
          {
            title: "Documents administratifs et académiques",
            desc: "Diplômes, relevés de notes, certificats scolaires, permis de conduire, pièces d’identité, casiers judiciaires, justificatifs de domicile, titres administratifs, etc.",
          },
        ],
      },

      interpreting: {
        title: "Interprétariat assermenté",

        languages: [
          "indonésien → français",
          "français → indonésien",
        ],

        intro: "Types d’interprétation proposés :",

        types: [
          {
            title: "Interprétation simultanée",
            desc: "Idéale pour conférences, séminaires et événements officiels",
          },
          {
            title: "Interprétation consécutive",
            desc: "Adaptée aux réunions, formations et négociations",
          },
          {
            title: "Interprétation à distance",
            desc: "Par téléphone ou visioconférence",
          },
        ],
      },

      cta: {
        submit: "Demander un devis",
      },
    },

    about: {
      title: "À Propos",
      section1: {
        title: "Mon expertise au service de vos projets, l’humain au cœur de ma démarche",
        text: "Traductrice-interprète assermentée en indonésien et malaisien près la Cour d’appel de Toulouse, j’accompagne particuliers et professionnels dans la traduction certifiée de leurs documents officiels sur l’ensemble du territoire français."
      },
      section2: {
        title: "Une expertise au croisement des cultures",
        paragraphs: [
          "Mon métier ne se limite pas aux mots : il s’appuie sur une véritable expérience de terrain entre Paris et Jakarta. Après une Maîtrise en Langues Etrangères Appliquées (indonésien-anglais) et un Master en Affaires Internationales, j’ai occupé différentes postes au sein de grandes entreprises implantées à Jakarta, où j’ai pu intégrer les codes et les exigences du monde professionnel indonésien.",
          "J’ai ensuite exercé pendant 11 ans à l’Ambassade d’Indonésie à Paris (Services Consulaire, Économique et Commercial), une mission centrée sur la traduction quotidienne de documents officiels et administratifs.",
          "Ce parcours m’a conféré une maîtrise pointue des réalités institutionnelles et interculturelles, en France comme en Indonésie. Aujourd’hui indépendante, je collabore régulièrement avec différents ministères (Intérieur, Justice, Économie) ainsi qu’avec de grands groupes internationaux. En 5 ans, j’ai accompagné plusieurs centaines de clients et traduit plus de 800 documents officiels."
        ]
      },
      section3: {
        title: "Bienveillance et rigueur juridique",
        paragraphs: [
          "Ce qui m’anime avant tout, c’est la dimension humaine de mon métier. Je sais qu’une traduction est souvent la clé d’un projet de vie : un mariage, une naturalisation, un cursus d’études, une installation en France ou une procédure judiciaire.",
          "Mon rôle est de vous accompagner avec écoute et clarté, tout en garantissant une confidentialité absolue et une rigueur juridique sans faille."
        ]
      },
      section4: {
        title: "Mon engagement",
        text: "Proposer des traductions fiables, précises et reconnues légalement, pour simplifier vos démarches et sécuriser vos projets d’avenir."
      }
    },

    process: {
      title: "Accompagnement",
      subtitle: "Un processus simple et sécurisé",

      steps: [
        {
          title: "Envoi des documents",
          desc: "Transmettez vos documents via la plateforme sécurisée ou par email",
        },
        {
          title: "Analyse et devis",
          desc: "Recevez un devis personnalisé et le délai de livraison",
        },
        {
          title: "Paiement sécurisé",
          desc: "Le règlement s’effectue par virement bancaire afin de lancer la traduction",
        },
        {
          title: "Livraison",
          desc: "Recevez votre traduction certifiée en PDF par email, puis l’original par courrier postal",
        },
      ],
    },

    contact: {
      title: "Contact",

      details: {
        email: "E-mail",
        phone: "Téléphone",
        address: "Adresse",
      },

      addressLines: [
        "20 rue Cujas",
        "31000 Toulouse",
        "France",
      ],

      business: {
        title: "Entreprise individuelle",
        status: " ",
        siret: "N° Siret : 83828090700018",
      },
    },

    submission: {
      title: "Demander un devis",
      subtitle: "Simple & Rapide",

      bullets: [
        "Devis gratuit et sans engagement",
        "Téléchargez votre document et recevez un tarif précis et un délai garanti",
        "Confidentialité absolue assurée",
      ],

      form: {
        name: "Nom complet",
        email: "Adresse e-mail",
        phone: "Numéro de téléphone",
        file: "Télécharger le document",
        notes: "Notes",

        placeholders: {
          name: " ",
          email: " ",
          phone: " ",
          notes: "Décrivez votre demande, le nombre de pages, les langues concernées...",
        },

        submit: "Envoyer",
        submitting: "Submitting...",
      },

      messages: {
        uploadRequired: "Please upload a file before submitting.",
        success: "Success",
        error: "Error: Could not submit",
      },
    },

    footer: {
      description:
        "Sophie Guérande - Traductrice assermentée par les tribunaux pour le français, l'indonésien et le malais, avec plus de 15 ans d'expérience et spécialisée dans les documents juridiques, financiers et commerciaux.",

      contact: {
        email: "E-mail",
        phone: "Téléphone",
        address: "Adresse",
        addressLines: [
          "20 rue Cujas",
          "31000 Toulouse",
          "France",
        ],
      },

      legal: {
        title: "Informations Légales",
        privacy: "Politique de Confidentialité",
        notice: "Mentions légales",
      },

      bottom: "Tous droits réservés.",
    },
  },

  id: {
    nav: {
      home: "Beranda",
      services: "Layanan",
      about: "Tentang",
      process: "Prosedur",
      contact: "Kontak",
      submit: "Kirim Dokumem",
    },
    company: {
      title: "Penerjemah Tersumpah",
    },

    companyIntro: {
      title: {
        name: "Sophie Guérande",
        subtitle: "Penerjemah & Juru Bahasa Tersumpah",
      },

      section1: {
        title: "Terjemahan tersertifikasi dalam bahasa Indonesia, bahasa Melayu & bahasa Prancis",
        paragraphs: [
          "Saya mendampingi Anda dalam seluruh keperluan administrasi resmi melalui layanan terjemahan tersertifikasi yang akurat dan sesuai dengan ketentuan hukum yang berlaku.",
          "Pengalaman dan keahlian saya didedikasikan untuk memberikan hasil terjemahan yang sah secara hukum dengan jaminan kerahasiaan penuh."
        ]
      },

      section2: {
        title: "Kombinasi Bahasa:",
        languages: [
          "Terjemahan tersertifikasi / tersumpah",
          "Bahasa Indonesia ↔ Bahasa Prancis",
          "Bahasa Malaysia → Bahasa Prancis",
          "Terjemahan profesional",
          "Bahasa Indonesia ↔ Bahasa Inggris",
        ],
      },

      stats: {
        experience: {
          value: "15+",
          label: "Tahun Pengalaman",
        },
        delivery: {
          value: "3–5",
          label: "Hari Kerja (Waktu pengerjaan standar)",
        },
        documents: {
          value: "800+",
          label: "Dokumen diterjemahkan",
        },
        satisfaction: {
          value: "100%",
          label: "Kepuasan Klien",
        },
      },

      cta: {
        button: "Kirim Dokumen",
        note: "Terjemahan cepat, aman, dan diakui secara hukum — dikirimkan melalui email dan pos",
      },
    },

    services: {
      title: "Layanan",

      translation: {
        subtitle: "Terjemahan Tersertifikasi / Tersumpah",

        languages: [
          "Bahasa Indonesia → Bahasa Prancis",
          "Bahasa Melayu → Bahasa Prancis",
          "Bahasa Prancis → Bahasa Indonesia",
        ],

        intro: "Untuk segala keperluan administrasi resmi Anda:",

        sections: [
          {
            title: "Catatan Sipil &amp; Dokumen Keluarga",
            desc: "Akta kelahiran, surat keterangan belum menikah, akta nikah, akta cerai, akta kematian, buku keluarga, dll.",
          },
          {
            title: "Dokumen Hukum",
            desc: "Putusan pengadilan, akta notaris, surat panggilan, surat kuasa, kontrak, perjanjian, dll.",
          },
          {
            title: "Dokumen Administratif &amp;Akademik",
            desc: "Ijazah, transkrip nilai, sertifikat sekolah, SIM, tanda pengenal (KTP/Paspor), SKCK, bukti domisili, dll.",
          },
        ],
      },

      interpreting: {
        title: "Layanan Juru Bahasa Tersumpah",

        languages: [
          "Bahasa Indonesia → Bahasa Prancis",
          "Bahasa Prancis → Bahasa Indonesia",
        ],

        intro: "Jenis layanan juru bahasa yang tersedia:",

        types: [
          {
            title: "Interpretasi Simultan",
            desc: "Cocok untuk konferensi, seminar, dan acara resmi",
          },
          {
            title: "Interpretasi Konsekutif",
            desc: "Digunakan dalam rapat, pelatihan dan negosiasi",
          },
          {
            title: "Interpretasi Jarak Jauh",
            desc: "Melalui telepon atau konferensi video",
          },
        ],
      },

      cta: {
        submit: "Kirim Dokumen",
      },
    },

    about: {
      title: "Tentang",
      section1: {
        title: "Keahlian dan Sentuhan Manusia dalam Setiap Proyek",
        text: "Nama saya Sophie Guérande, saya adalah penerjemah-juru bahasa lisan tersumpah yang diakui oleh Pengadilan Negeri Kota Toulouse. Saya mendampingi klien perorangan maupun profesional di seluruh wilayah Prancis dalam penerjemahan tersertifikasi/tersumpah untuk dokumen resmi."
      },
      section2: {
        title: "Keahlian di Persimpangan Budaya",
        paragraphs: [
          "Keahlian saya tidak hanya sebatas kata-kata, tetapi berakar pada pengalaman langsung antara Paris dan Jakarta. Setelah menyelesaikan pendidikan Magister di bidang Bahasa Asing Terapan (Indonesia–Inggris) serta Magister di bidang Hubungan Internasional, saya bekerja di dua perusahaan besar di Jakarta, di mana saya mendalami budaya profesional serta etika bisnis Indonesia.",
          "Selanjutnya, saya bertugas selama 11 tahun di Kedutaan Besar Republik Indonesia di Paris (Bagian Konsuler, Ekonomi, dan Perdagangan), menerjemahkan berbagai dokumen resmi dan administratif setiap hari.",
          "Pengalaman bertahun-tahun ini memberi saya pemahaman yang mendalam mengenai realitas institusional, administratif, dan lintas budaya — baik di Prancis maupun di Indonesia. Kini, sebagai profesional independen, saya secara rutin bekerja sama dengan berbagai kementerian Prancis (Kementerian Dalam Negeri, Kehakiman, Ekonomi) serta sejumlah grup internasional besar.",
          "Dalam 5 tahun terakhir, saya telah mendampingi ratusan klien dan menerjemahkan lebih dari 800 dokumen resmi."
        ]
      },
      section3: {
        title: "Kepedulian dan Ketepatan Hukum",
        paragraphs: [
          "Hal yang paling memotivasi saya adalah dimensi manusiawi dari profesi ini. Saya menyadari bahwa sebuah terjemahan sering kali menjadi kunci bagi rencana besar dalam hidup seseorang: pernikahan, naturalisasi, rencana studi, pindah ke Prancis, atau prosedur hukum.",
          "Peran saya adalah mendampingi Anda dengan komunikasi yang jelas dan penuh perhatian, dan profesional, sambil menjamin kerahasiaan penuh serta ketepatan hukum yang sempurna."
        ]
      },
      section4: {
        title: "Komitmen saya",
        text: "Terjemahan yang tepercaya, akurat, dan diakui secara hukum — untuk mempermudah prosedur administratif dan memberikan ketenangan bagi setiap langkah penting Anda."
      }
    },

    process: {
      title: "Prosedur",
      subtitle: "Proses Sederhana & Aman",

      steps: [
        {
          title: "Pengiriman Dokumen",
          desc: "Unggah dokumen Anda melalui platform aman atau melalui email",
        },
        {
          title: "Analisis & Perkiraan biaya",
          desc: "Dapatkan perkiraan biaya/penawaran harga yang disesuaikan beserta estimasi waktu pengerjaan",
        },
        {
          title: "Pembayaran Aman",
          desc: "Pembayaran dilakukan melalui transfer bank untuk memulai proses penerjemahan",
        },
        {
          title: "Pengiriman Hasil",
          desc: "Terima hasil terjemahan tersertifikasi dalam format PDF melalui email, kemudian dokumen asli akan dikirimkan melalui pos",
        },
      ],
    },

    contact: {
      title: "Kontak",

      details: {
        email: "E-mail",
        phone: "Telepon",
        address: "Alamat",
      },

      addressLines: [
        "20 rue Cujas",
        "31000 Toulouse",
        "France",
      ],

      business: {
        title: "Informasi Usaha",
        status: "Perusahaan Perorangan",
        siret: "Nomor Siret : 83828090700018",
      },
    },

    submission: {
      title: "Permintaan Perkiraan Biaya",
      subtitle: "Mudah & Cepat",

      bullets: [
        "Penawaran gratis dan tanpa kewajiban/ikatan",
        "Unggah dokumen Anda untuk mendapatkan perkiraan biaya/estimasi harga yang tepat beserta jaminan waktu penyelesaian",
        "Kerahasiaan data Anda sepenuhnya terjamin",
      ],

      form: {
        name: "Nama Lengkap",
        email: "Alamat E-mail",
        phone: "Nomor Telepon",
        file: "Unggah Dokumen",
        notes: "Catatan",

        placeholders: {
          name: " ",
          email: " ",
          phone: " ",
          notes: "Jelaskan permintaan Anda, jumlah halaman, dan bahasa yang terlibat...",
        },

        submit: "Kirim",
        submitting: "Submitting...",
      },

      messages: {
        uploadRequired: "Please upload a file before submitting.",
        success: "Success",
        error: "Error: Could not submit",
      },
    },

    footer: {
      description:
        "Sophie Guérande - Penerjemah bersertifikat pengadilan untuk bahasa Prancis, Indonesia, dan Melayu, dengan pengalaman lebih dari 15 tahun dan spesialisasi dalam dokumen hukum, keuangan, dan komersial.",

      contact: {
        email: "E-mail",
        phone: "Telepon",
        address: "Alamat",
        addressLines: [
          "20 rue Cujas",
          "31000 Toulouse",
          "France",
        ],
      },

      legal: {
        title: "Informasi Hukum",
        privacy: "Kebijakan Privasi",
        notice: "Keterangan Hukum",
      },

      bottom: "Hak cipta dilindungi undang-undang",
    },
  },
};

export default translation;